<template>
  <label class="checkbox" :disabled="isDisabled">
    <input :checked="isChecked" :value="cbVal" :disabled="isDisabled" type="checkbox" @change="$emit('cb-toggle', $event.target.checked)">
    <span :style="{'--boxColor':color, ...styleObj}" class="checkmarkBox"></span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  name: 'ColoredCheckbox',
  props: {
    cbVal: {
      type: [String, Number, Boolean],
      default: 1
    },
    color: {
      type: String,
      default: '#30aae1'
    },
    styleObj: {
      type: String,
      default: ''
    },
    isChecked: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.checkbox {
  line-height: 0;
  height: 13px;
  width: 13px;
}

input[type="checkbox"] {
  -webkit-appearance: none;
}

/* Create a custom checkbox */
.checkmarkBox {
  position: absolute;
  top: 0;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: #fff;
  border: 1px solid #b2b2b2;
}

/* When the checkbox is checked, add a blue background */
input:checked ~ .checkmarkBox {
  border: none;
  background-color: var(--boxColor);
}

/* Create the checkmark (hidden when not checked) */
.checkmarkBox:after {
  content: "";
  position: absolute;
  display: none;
  left: 5px;
  top: 2px;
  width: 5px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Show the checkmark when checked */
input:checked ~ .checkmarkBox:after {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/ColoredCheckbox.vue